import * as React from "react";
import { EditableField } from "../../../components/editable-field";
import { Boat, CreateBoatDTO } from "../../../types/boat.types";
import { Button } from "../../../components/button";

export interface IBoatFormBaseProps {
  title?: string;
  buttonText: string;
  buttonVariant?: "create" | "save";
  handleChange: (e: React.ChangeEvent<HTMLElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}
interface IBoatFormEditProps extends IBoatFormBaseProps {
  boat: Pick<Boat, "id" | "name" | "registration_number" | "engine_brand" | "hp" | "has_radio" | "is_yacht">;
  createBoat?: never;
}
interface IBoatFormCreateProps extends IBoatFormBaseProps {
  boat?: never;
  createBoat: CreateBoatDTO;
}
export type IBoatFormProps = IBoatFormEditProps | IBoatFormCreateProps;

export default function BoatForm({
  title,
  buttonText,
  buttonVariant,
  boat,
  createBoat,
  handleChange,
  onSubmit,
  onCancel,
  isSubmitting,
}: IBoatFormProps) {
  const currentBoat = boat ?? createBoat;

  return (
    <form onSubmit={onSubmit}>
      <div className="flex space-x-2">
        {title && (
          <h2 className="text-2xl font-bold text-center text-gray-600">
            {title}
          </h2>
        )}
      </div>
      <div className="space-y-4">
        <EditableField
          label="Nombre"
          value={currentBoat!.name ?? ""}
          type="text"
          onChange={(e) => handleChange(e)}
          placeholder="Ingrese el nombre de la embarcación"
          name="name"
          required
          minLength={3}
          maxLength={20}
        />
        <EditableField
          label="Matrícula"
          value={currentBoat!.registration_number ?? ""}
          type="text"
          placeholder="Ingrese la matrícula de la embarcación"
          onChange={(e) => handleChange(e)}
          name="registration_number"
          required
        />
        <EditableField
          label="Marca de Motor"
          value={currentBoat!.engine_brand ?? ""}
          type="text"
          onChange={(e) => handleChange(e)}
          name="engine_brand"
          placeholder="Ingrese la marca de motor de la embarcación"
          minLength={2}
          maxLength={20}
          required
        />
        <EditableField
          label="HP"
          value={currentBoat!.hp ?? ""}
          type="number"
          onChange={(e) => handleChange(e)}
          name="hp"
          placeholder="Ingrese los HP del motor de la embarcación"
          min={1}
          max={1000}
          required
        />
        <EditableField
          label="Radio"
          value={currentBoat!.has_radio ?? false}
          type="checkbox"
          onChange={(e) => handleChange(e)}
          name="has_radio"
        />
        <EditableField
          label="Yate"
          value={currentBoat!.is_yacht ?? false}
          type="checkbox"
          onChange={(e) => handleChange(e)}
          name="is_yacht"
        />
      </div>
      <div className="flex justify-end space-x-2 mt-4">
        <Button onClick={onCancel} text="Cancelar" variant="cancel" />
        <Button type="submit" text={buttonText} variant={buttonVariant || "create"} disabled={isSubmitting} />
      </div>
    </form>
  );
} 
